import { render, staticRenderFns } from "./ProfileMenuCompanyMobile.vue?vue&type=template&id=3680f365&scoped=true"
import script from "./ProfileMenuCompanyMobile.vue?vue&type=script&lang=js"
export * from "./ProfileMenuCompanyMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3680f365",
  null
  
)

export default component.exports